/**
 *
 * T
 *
 */

import React from 'react'
import styled from 'styled-components'
import { FormattedMessage } from 'react-intl'

const StyledWrapper = styled.span`
  ${props => props.allCaps && `text-transform: uppercase;`};
`
export default function T ({ allCaps, prefix, ...props }) {
  if (!props.id) {
    return ''
  }
  const id = `${prefix ? `${prefix}.` : ''}${props.id.toLowerCase()}`
  return (
    <StyledWrapper data-lokalise data-key={id} allCaps={allCaps}>
        <FormattedMessage {...props} id={id} />
    </StyledWrapper>
  )
}
